<template>
  <div class="sencond-menu-box">
    <div class="header-img">
      <img src="@/assets/images/banner-li.jpg">
    </div>
    <div class="sencond-menu-main">
      <AsideNav class="aside-menu-list"></AsideNav>
      <div class="right-container">
        <div class="ctep-breadcrumb">
          <CtepBreadcrumb></CtepBreadcrumb>
        </div>
        <router-view class="router-view-box" :key="$route.fullPath"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import AsideNav from './comp/AsideNav.vue';
import CtepBreadcrumb from "./comp/CtepBreadcrumb.vue"
export default {
  name: "secondMenu",
  components: {
    AsideNav,
    CtepBreadcrumb
  },
}
</script>

<style lang="scss" scoped>
.sencond-menu-box {
  .header-img {
    margin-top: 5px;
  }
  .sencond-menu-main {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
    .right-container {
      border-left: 1px solid #ddd;
      padding-left: 30px;
      width: calc(100% - 240px);
      .ctep-breadcrumb {
        padding-bottom: 15px;
      }
      .router-view-box {
        min-height: 200px;
      }
    }
  }
}
</style>